import React from 'react'
import SellClass from '../../components/admin/SaleGroupClass/SellClass'

function SellGroupForm({defaultStep}) {
  return <SellClass defaultStep={defaultStep} />
}

export default SellGroupForm
